import React, { useEffect, useState } from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useNetworkStatus } from '../../hooks/useNetworkStatus';
import { OfflineCache } from '../../utils/OfflineCache';
import { API } from '../../utils/callAPI';
import { useDispatch } from 'react-redux';
import { FicheAutocontroleActionTypes } from '../../store/types/FicheAutocontrole.Types';

const OfflineSync: React.FC = () => {
  const isOnline = useNetworkStatus();
  const dispatch = useDispatch();
  const [showOffline, setShowOffline] = useState(false);
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setShowOffline(true);
      return;
    }
    if (!OfflineCache.hasPendingData()) return;

    const syncData = async () => {
      const pending = OfflineCache.load();
      if (!pending) return;
      setSyncing(true);
      try {
        await API.updateAutocontrole(pending.tabToSave, pending.percentCompletion, pending.statut);
        OfflineCache.clear();
        dispatch({ type: FicheAutocontroleActionTypes.SET_ISSAVED, payload: true });
      } catch (e) {
        console.error('Sync failed:', e);
      } finally {
        setSyncing(false);
      }
    };

    syncData();
  }, [isOnline]);

  return (
    <>
      <Snackbar open={!isOnline && showOffline} onClose={() => setShowOffline(false)}>
        <Alert severity="warning">Mode hors ligne - Vos données sont sauvegardées localement</Alert>
      </Snackbar>
      <Snackbar open={syncing}>
        <Alert severity="info">Synchronisation en cours...</Alert>
      </Snackbar>
    </>
  );
};

export default OfflineSync;
